/**
 *
 * @author Igor Zapororzhets <deadbyelpy@gmail.com>.
 */

'use strict';


/* eslint no-use-before-define: 0*/
/* eslint no-useless-call: 0 */


var app  = require('mag-app'),
    keys = require('stb-keys'),

    Modal = require('mag-component-modal'),
    ProgressBar  = require('spa-component-progress-bar'),

    nodeMap = require('../node.map.js'),
    listItemRender = require('./list.item'),

    progressBar = new ProgressBar({
        focusable: true,
        events: {
            keydown: function ( event ) {
                switch ( event.code ) {
                    case keys.right:
                        this.set(this.value + currentOption.config.step);
                        break;

                    case keys.left:
                        this.set(this.value - currentOption.config.step);
                        break;

                    case keys.back:
                        event.stop = true;
                        modal.hide();
                        break;

                    case keys.ok:
                        if ( currentOption.saveImmediate ) {
                            if ( typeof currentOption.prepareForSave === 'function' ) {
                                currentOption.prepareForSave.call(currentOption, progressBar.value, function ( error, afterSave ) {
                                    if ( !error ) {
                                        currentOption.saver.call(currentOption, function ( error, callback ) {
                                            if ( !error ) {
                                                currentOption.config.value = progressBar.value;
                                                if ( typeof afterSave === 'function' ) {
                                                    afterSave.call(currentOption);
                                                }
                                            }

                                            if ( typeof callback === 'function' ) {
                                                callback.call(currentOption, error);
                                            }
                                        });
                                    }
                                });
                            } else {
                                currentOption.saver.call(currentOption, function ( error, callback ) {
                                    if ( !error ) {
                                        currentOption.config.value = progressBar.value;
                                    }

                                    if ( typeof callback === 'function' ) {
                                        callback.call(currentOption, error);
                                    }
                                });
                            }
                        } else {
                            nodeMap.data[currentOption.id].listInstance.$nodeChange(
                                currentOption.config.value !== progressBar.value,
                                currentOption,
                                progressBar.value
                            );
                        }
                        event.stop = true;
                        modal.hide();
                        break;

                    default:
                        break;
                }
            }
        }
    }),
    modal = new Modal({
        title: 'Choose',
        children: [progressBar],
        events: {
            show: function () {
                app.activePanelSet.blur();
                progressBar.focus();
            },
            hide: function () {
                app.activePanelSet.focus();
            }
        }
    }),
    $progressValue = document.createElement('div'),
    $rangeInput = document.createElement('div'),
    currentOption = null;


$rangeInput.className = 'range-input';
progressBar.$value.classList.add('osdFocusItem');
$rangeInput.appendChild(progressBar.$node);
$rangeInput.appendChild($progressValue);
modal.$body.appendChild($rangeInput);
$progressValue.className = 'textValue';

progressBar.addListener('change', function ( event ) {
    $progressValue.innerText = event.curr;
});

module.exports = function ( value, callback ) {
    var self = this;

    self.config.value = +value;

    listItemRender.call(this, null, function () {
        nodeMap.data[self.id].onclick = function () {
            modal.$text.innerText = self.name;

            if ( modal.parent ) {
                if ( app.activePage !== modal.parent ) {
                    modal.parent.remove(modal);
                    app.activePage.add(modal);
                }
            } else {
                app.activePage.add(modal);
            }

            currentOption = self;
            progressBar.init({
                min: self.config.min,
                max: self.config.max,
                value: self.config.value
            });
            currentOption.config.step = self.config.step || 1;
            $progressValue.innerText = self.config.value;
            setTimeout(function () {
                modal.show();
            }, 0);
        };

        callback();
    });
};
